// src/hooks/programs/useGetPrograms.js
import { useQuery } from "@tanstack/react-query";
import { getAllPrograms } from "../../api/apiPrograms";
import i18next from "i18next";

const useGetPrograms = (page = 1, perPage = 15, filters = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["programs", page, perPage, filters, i18next.language],
        queryFn: () => getAllPrograms(page, perPage, filters),
    });

    return {
        programs: data?.data || {},
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch,
    };
};

export default useGetPrograms;
